export default "__VITE_ASSET__DG1CaKo4__"